// Seçili satırın ayrıntı paneli (P2): ad, kod, "Neden pakette?" ve paket varsayılanları (birim,
// aktif formül, değişim sütunu — `PackageDefaultsBody`). ≥1280 px'te yan sütun, daha dar ekranda
// seçili satırın altında açılır alan (`inline`). Varsayılanlar yalnız TASLAĞA yazar.

import type { PackageDefaults } from "../../lib/kpi-package-draft";
import type { WhyInPackage } from "../../lib/kpi-package-editor";
import { KPI_PACKAGES_COPY } from "../../lib/kpi-packages-copy";
import { PackageDefaultsBody, type DefaultsMetric } from "./PackageDefaultsBody";
import { decisionText, helpText, hitArea44, hitArea44Visual, monoStyle } from "./kpi-form-styles";

const C = KPI_PACKAGES_COPY;

export function whyText(why: WhyInPackage): string {
  switch (why.kind) {
    case "manual":
      return C.why.manual;
    case "auto":
      return why.forLabel ? C.why.auto(why.forLabel) : C.why.autoBare;
    case "breakdown":
      return C.why.breakdown(why.totalLabel);
    case "ai":
      return C.why.ai(why.reason);
  }
}

export interface PackageDetailPanelProps {
  metric: DefaultsMetric & { code: string };
  why: WhyInPackage;
  /** üye değilse (çıkarılacak) varsayılan düzenlenmez */
  isMember: boolean;
  value: PackageDefaults;
  disabled: boolean;
  inline?: boolean;
  onChange: (patch: Partial<PackageDefaults>) => void;
  onClose: () => void;
}

export function PackageDetailPanel(p: PackageDetailPanelProps): JSX.Element {
  const { metric } = p;
  return (
    <section
      aria-label={p.inline ? C.detail.inlineLabel(metric.label) : metric.label}
      data-testid={p.inline ? "package-detail-inline" : "package-detail-panel"}
      className="rounded-xl p-4"
      style={{
        background: "var(--color-surface)",
        border: "1px solid var(--color-border)",
        fontFamily: "var(--font-sans)",
      }}
    >
      <div className="flex items-start gap-2" style={{ marginBottom: 8 }}>
        <div className="min-w-0 flex-1">
          <div style={{ ...decisionText, fontWeight: 700 }}>{metric.label}</div>
          <div style={{ ...monoStyle, color: "var(--color-text-2)" }}>{metric.code}</div>
        </div>
        <button
          type="button"
          aria-label={C.detail.closeLabel}
          onClick={p.onClose}
          style={hitArea44}
        >
          <span style={hitArea44Visual}>✕</span>
        </button>
      </div>
      <h3 style={{ ...helpText, fontWeight: 600, margin: "0 0 2px" }}>{C.why.title}</h3>
      <p style={{ ...decisionText, margin: "0 0 12px" }} data-testid="package-why">
        {whyText(p.why)}
      </p>
      {p.isMember ? (
        <>
          <p style={{ ...helpText, margin: "0 0 8px" }}>{C.defaults.note}</p>
          <PackageDefaultsBody
            metric={metric}
            value={p.value}
            disabled={p.disabled}
            onChange={p.onChange}
          />
        </>
      ) : null}
    </section>
  );
}
